export const environment = {
  production: true,

  // URL of production API
  apiUrl: 'https://api.staging.wearandcare.com/api/',
  workerUrl: 'https://workerservice.staging.wearandcare.com/carehomehub'
};
